@if (useRijksVersion()) {
  <ng-container [ngTemplateOutlet]="rijksTemplate" />
} @else {
  <ng-container [ngTemplateOutlet]="tnghTemplate" />
}

<ng-template #rijksTemplate>
  <div class="login-wrapper">
    <header class="login-wrapper__header">
      <dsrks-hero
        [variant]="logoVariant"
        [logoUrl]="logoUrl"
        [logoAltText]="logoAltText"
        logoWidth="258"
        logoHeight="125"
      />
      <dsrks-topbar variant="rijks">
        <ng-container ngProjectAs="left">
          <p class="topbar-title">Wachtwoord instellen</p>
        </ng-container>
      </dsrks-topbar>
    </header>
    <div class="login-wrapper__content">
      <div class="login-wrapper__content__bg-image"></div>
      <form (ngSubmit)="onSubmit()" [formGroup]="formGroup" class="login-wrapper__form">
        <fieldset>
          <h2>Wachtwoord instellen</h2>
          <ds-form-grid>
            <div class="form-row">
              <ds-input
                class="span-12"
                formControlName="newPassword"
                i18n-label="@@newPasswordField"
                label="Nieuw wachtwoord"
                type="password"
              />
            </div>
            <div class="form-row">
              <ds-input
                class="span-12"
                formControlName="confirmPassword"
                i18n-label="@@confirmPasswordField"
                label="Bevestig nieuw wachtwoord"
                type="password"
              />
            </div>
          </ds-form-grid>
        </fieldset>
        <div class="login-wrapper__cta">
          <ds-button i18n="Set password button@@ResetPasswordPageButton" type="submit">Wachtwoord instellen</ds-button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #tnghTemplate>
  <div class="login-screen">
    <form (ngSubmit)="onSubmit()" [formGroup]="formGroup" class="login-form">
      <fieldset>
        <legend class="form-card-form-wrapper__legend" i18n>Wachtwoord instellen</legend>
        <tngh-form-grid>
          <tngh-text-input
            class="span-6"
            formControlName="newPassword"
            i18n-label="@@newPasswordField"
            label="Nieuw wachtwoord"
            type="password"
          ></tngh-text-input>
          <tngh-text-input
            class="span-6"
            formControlName="confirmPassword"
            i18n-label="@@confirmPasswordField"
            label="Bevestig nieuw wachtwoord"
            type="password"
          ></tngh-text-input>
        </tngh-form-grid>
      </fieldset>

      <div class="login-screen__cta">
        <tngh-button
          [fullwidth]="true"
          i18n="Set password button@@ResetPasswordPageButton"
          i18n-label="@@setPasswordSubmitButton"
          label="Wachtwoord instellen"
          type="submit"
        ></tngh-button>
      </div>
    </form>
  </div>
</ng-template>
